import "core-js/modules/web.dom-exception.stack.js";
import "core-js/modules/web.structured-clone.js";
import { createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, Teleport as _Teleport } from "vue";
const _hoisted_1 = {
  key: 0,
  class: "role-attribute"
};
const _hoisted_2 = {
  class: "left-side"
};
const _hoisted_3 = {
  class: "attribute-item-group"
};
const _hoisted_4 = {
  class: "attribute-item-value"
};
const _hoisted_5 = {
  class: "attribute-item-value"
};
const _hoisted_6 = {
  class: "attribute-item-value reputation"
};
const _hoisted_7 = {
  class: "attribute-item-value"
};
const _hoisted_8 = {
  class: "attribute-item-value"
};
const _hoisted_9 = {
  class: "attribute-item-value"
};
const _hoisted_10 = {
  class: "attribute-item-value"
};
const _hoisted_11 = {
  class: "attribute-item-value"
};
const _hoisted_12 = {
  class: "attribute-item-value"
};
const _hoisted_13 = {
  class: "attribute-item-value"
};
const _hoisted_14 = {
  class: "attribute-item-value"
};
const _hoisted_15 = {
  class: "attribute-item-value special"
};
const _hoisted_16 = {
  class: "attribute-item-value"
};
const _hoisted_17 = {
  class: "attribute-item-value"
};
const _hoisted_18 = {
  class: "attribute-item-group"
};
const _hoisted_19 = {
  key: 0
};
const _hoisted_20 = {
  class: "attribute-item-title"
};
const _hoisted_21 = {
  key: 0
};
const _hoisted_22 = {
  class: "attribute-item-value"
};
const _hoisted_23 = {
  class: "attribute-item-value"
};
const _hoisted_24 = {
  class: "attribute-item-value"
};
const _hoisted_25 = {
  class: "attribute-item-value"
};
const _hoisted_26 = {
  class: "attribute-item-value"
};
const _hoisted_27 = {
  class: "right-side"
};
const _hoisted_28 = {
  class: "attribute-item-group avatar-group"
};
const _hoisted_29 = ["src"];
const _hoisted_30 = {
  class: "biography"
};
const _hoisted_31 = {
  class: "attribute-item-group"
};
const _hoisted_32 = {
  class: "attribute-item-title"
};
const _hoisted_33 = {
  class: "attribute-item-value"
};
const _hoisted_34 = {
  style: {
    "margin-right": "0.5rem"
  }
};
const _hoisted_35 = {
  style: {
    "margin-right": "0.5rem"
  }
};
const _hoisted_36 = {
  style: {
    "margin-right": "0.5rem"
  }
};
const _hoisted_37 = {
  class: "attribute-item-value"
};
const _hoisted_38 = {
  class: "attribute-item-value"
};
const _hoisted_39 = {
  class: "attribute-item-value"
};
const _hoisted_40 = {
  class: "attribute-item-value"
};
const _hoisted_41 = {
  class: "attribute-item-group"
};
const _hoisted_42 = {
  style: {
    "margin-right": "0.5rem"
  }
};
const _hoisted_43 = {
  style: {
    "margin-right": "0.5rem"
  }
};
const _hoisted_44 = {
  style: {
    "margin-right": "0.5rem"
  }
};
const _hoisted_45 = {
  class: "attribute-item-title"
};
const _hoisted_46 = {
  class: "instruction-container"
};
const _hoisted_47 = {
  class: "instruction-value"
};
const _hoisted_48 = {
  class: "biography-container"
};
import { computed, ref, inject, watch } from 'vue';
import { ElButton, ElCol, ElMessage, ElRow, ElProgress, ElInput } from 'element-plus';
import { UserFilled, Postcard, Connection, Notebook, Coin } from '@element-plus/icons-vue';
import { getDamageAndBuild, getGender, getMovement, getProperty, getCapability, placeholderImage, isUserType, inApostleType, featOptions, gradientPercentageColors, getPercentage, isAdminType, uploadFile, compressImage, calculateMD5 } from '@/tools/utils';
import store from '@/store';
import { request } from '@/manager/net_manager';
import 'element-plus/es/components/divider/style/css';
import 'element-plus/es/components/select-v2/style/css';
import 'element-plus/es/components/progress/style/css';
import MaskerLayer from '@/components/Basic/MaskerLayer.vue';
import AssetAllocation from '@/components/Account/AssetAllocation.vue';
import router from "@/router"; // import CapabilityRadar from '@/components/Common/CapabilityRadar.vue'

export default {
  __name: 'RoleCardAttribute',
  props: {
    roleId: {
      type: [String, Number],
      required: true
    }
  },

  setup(__props) {
    const props = __props;
    const {
      update: updateData
    } = inject('roleService'); // refs

    const avatarInput = ref(null);
    const instructionMode = ref(false);
    const instruction = ref('');
    const allocationMode = ref(false);
    const biographyMode = ref(false);
    const biography = ref(''); // computed

    const userType = computed(() => store.state.user ? parseInt(store.state.user.user_type) : 4);
    const attribute = computed(() => store.state.role_info[props.roleId]?.attribute ?? null);
    const roleArray = computed(() => store.state.role_array ?? []);
    const wealthPoint = computed(() => {
      if (!attribute.value) return 0.0;
      return parseFloat(attribute.value.wealth_point);
    });
    const damageAndBuild = computed(() => {
      if (!attribute.value) return [['', ''], ['', '']];
      return [getDamageAndBuild(attribute.value), getDamageAndBuild(attribute.value, true)];
    });
    const sanityDesc = computed(() => {
      if (!attribute.value) {
        return '';
      }

      let sanityPoint = parseInt(attribute.value['sanity_point'] ?? '0');
      let mythology = parseInt(attribute.value['mythology'] ?? '0');
      let adjustSanityPoint = sanityPoint - attribute.value.properties.pow;
      let currentSanityPoint;

      if (attribute.value.properties.pow + mythology > 100) {
        currentSanityPoint = 100 - mythology + adjustSanityPoint;
      } else {
        currentSanityPoint = sanityPoint;
      }

      if (adjustSanityPoint === 0 && attribute.value.properties.pow + mythology <= 100) {
        return `${attribute.value['sanity_point']} / ${attribute.value['sanity_point']}`;
      }

      return `${currentSanityPoint.toString()} / (${attribute.value.properties.pow} -> ${currentSanityPoint.toString()})`;
    });
    const roleCapabilities = computed(() => store.state.role_info[props.roleId]?.role_capabilities ?? null);
    const roleSkills = computed(() => store.state.role_info[props.roleId]?.role_skills ?? null);
    const assignableCapabilityPoint = computed(() => {
      return store.state.role_info[props.roleId]?.capability_point ?? 0;
    });
    const assignableSkillsPoint = computed(() => {
      return store.state.role_info[props.roleId]?.skill_point ?? 0;
    });
    const roleCapabilitiesRadarData = computed(() => {
      if (!roleCapabilities.value) return [];
      return roleCapabilities.value.map(item => {
        const capabilityInfo = getCapability(item.capability_id, {
          'properties': attribute.value.properties
        });
        const capabilityValue = parseInt(capabilityInfo.baseValueCalc) + parseInt(item.nature_value) + parseInt(item.value) + parseInt(item.grew_value);
        return { ...item,
          'desc': capabilityInfo.desc,
          'type': capabilityInfo.type,
          'capability_value': capabilityValue
        };
      });
    }); // functions

    const getData = () => {
      updateData('attribute');
    }; // const getCapabilityTypePoint = (key = null) => {
    //   let buffer = roleCapabilitiesRadarData.value.filter(item => item['type'] === key)
    //   if (buffer.length === 0) return 0
    //   return buffer.reduce((sum, r) => sum + r.capability_value, 0)
    // }


    const clickAvatar = () => {
      avatarInput.value.click();
    };

    const handleInputChange = async event => {
      const file = event.target.files[0];

      if (file) {
        try {
          compressImage(file, 1024 * 1024, compressedFile => {
            calculateMD5(compressedFile, async md5Value => {
              const fileResponse = await uploadFile(file, md5Value, {
                'path': 'role_avatar',
                'role_id': props.roleId
              });

              if (fileResponse.code !== 0) {
                ElMessage.error({
                  message: fileResponse.msg,
                  duration: 1500
                });
                return;
              }

              const updateResponse = await request('role/update/', {
                'updates': {
                  'role_id': props.roleId,
                  'avatar': fileResponse.data.file_id
                }
              }, 'POST');

              if (updateResponse.code !== 0) {
                ElMessage.error({
                  message: updateResponse.msg,
                  duration: 1500
                });
                return;
              }

              let buffer = structuredClone(attribute.value);
              buffer['avatar'] = fileResponse.data.file_url;
              store.commit('update_role_info', {
                role_id: props.roleId,
                key: 'attribute',
                value: buffer
              });
              ElMessage.success({
                message: '信息更新完成',
                duration: 1500
              });
            });
          });
        } finally {
          avatarInput.value.value = null;
        }
      }
    };

    const switchLeadRole = () => {
      request('role/update/', {
        'updates': {
          'role_id': props.roleId,
          'lead': true
        }
      }, 'POST').then(response => {
        // console.log(JSON.stringify(response))
        if (response.code !== 0) {
          ElMessage.error({
            message: response.msg,
            duration: 1500
          });
          return;
        }

        let buffer = structuredClone(store.state.role_info);
        buffer[props.roleId]['attribute']['is_lead'] = true;
        const roleIds = Object.keys(store.state.role_info).filter(item => item !== props.roleId);

        for (const roleId of roleIds) {
          buffer[roleId]['attribute']['is_lead'] = false;
        }

        store.commit('update_all_role_info', buffer);
        store.commit('update_selected_role', props.roleId);
        ElMessage.success({
          message: '身份切换完成',
          duration: 1500
        });
      });
    };

    const submitBiography = () => {
      request('role/update/', {
        'updates': {
          'role_id': props.roleId,
          'biography': biography.value
        }
      }, 'POST').then(response => {
        // console.log(JSON.stringify(response))
        if (response.code !== 0) {
          ElMessage.error({
            message: response.msg,
            duration: 1500
          });
          return;
        }

        let buffer = structuredClone(attribute.value);
        buffer['biography'] = biography.value;
        biography.value = '';
        biographyMode.value = false;
        store.commit('update_role_info', {
          role_id: props.roleId,
          key: 'attribute',
          value: buffer
        });
        ElMessage.success({
          message: '信息更新完成',
          duration: 1500
        });
      });
    };

    const rebuildRole = () => {
      router.push({
        name: 'roleGenerator',
        params: {
          roleId: props.roleId
        }
      });
    };

    const getInstruction = async () => {
      let sanity_point = attribute.value.sanity_point;

      if (parseInt(attribute.value.sanity_point) + parseInt(attribute.value.mythology) > 100) {
        sanity_point = 100 - parseInt(attribute.value.mythology);
      }

      let buffer = `.st hp${attribute.value.health_point}mp${attribute.value.magic_point}san${sanity_point}神话${attribute.value.mythology}`;

      for (const key in attribute.value.properties) {
        const value = attribute.value.properties[key];
        buffer += `${key}${value}${getProperty(key)}${value}`;
      }

      for (let i = 0; i < roleCapabilitiesRadarData.value.length; i++) {
        const capabilityItem = roleCapabilitiesRadarData.value[i];
        const titleArray = capabilityItem.desc.split('/').map(part => part.trim());

        for (let j = 0; j < titleArray.length; j++) {
          buffer += `${titleArray[j]}${capabilityItem.capability_value}`;
        }
      }

      buffer += roleSkills.value.map(item => `${item.name}${item.probability}`).join('');

      try {
        await navigator.clipboard.writeText(buffer);
        ElMessage.success({
          message: '指令已复制',
          duration: 1500
        });
      } catch (err) {
        instruction.value = buffer;
        instructionMode.value = true;
      }
    }; // watcher


    watch(() => attribute.value, newVal => {
      if (!newVal) getData();
    });
    return (_ctx, _cache) => {
      const _component_el_icon = _resolveComponent("el-icon");

      const _component_el_image = _resolveComponent("el-image");

      return _openBlock(), _createElementBlock(_Fragment, null, [_createElementVNode("input", {
        type: "file",
        accept: "image/png, image/jpeg",
        style: {
          "display": "none"
        },
        ref_key: "avatarInput",
        ref: avatarInput,
        onChange: handleInputChange
      }, null, 544), attribute.value ? (_openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createVNode(_unref(ElRow), {
        class: "attribute-group-title-row"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_icon, {
          size: 18
        }, {
          default: _withCtx(() => [_createVNode(_unref(UserFilled))]),
          _: 1
        }), _cache[8] || (_cache[8] = _createElementVNode("text", {
          class: "group-title"
        }, "角色基础", -1))]),
        _: 1
      }), _createVNode(_unref(ElRow), {
        class: "attribute-item-row"
      }, {
        default: _withCtx(() => [_cache[9] || (_cache[9] = _createElementVNode("text", {
          class: "attribute-item-title"
        }, "链接器id", -1)), _createElementVNode("text", _hoisted_4, _toDisplayString(attribute.value['id']), 1)]),
        _: 1
      }), _unref(inApostleType)(userType.value) ? (_openBlock(), _createBlock(_unref(ElRow), {
        key: 0,
        class: "attribute-item-row"
      }, {
        default: _withCtx(() => [_cache[10] || (_cache[10] = _createElementVNode("text", {
          class: "attribute-item-title"
        }, "从属用户", -1)), _createElementVNode("text", _hoisted_5, _toDisplayString(`${attribute.value.owner.user_id} - ${attribute.value.owner.nickname}`), 1)]),
        _: 1
      })) : _createCommentVNode("", true), attribute.value.reputation && attribute.value.reputation.length > 0 ? (_openBlock(), _createBlock(_unref(ElRow), {
        key: 1,
        class: "attribute-item-row"
      }, {
        default: _withCtx(() => [_cache[11] || (_cache[11] = _createElementVNode("text", {
          class: "attribute-item-title"
        }, "称号", -1)), _createElementVNode("text", _hoisted_6, _toDisplayString(attribute.value.reputation), 1)]),
        _: 1
      })) : _createCommentVNode("", true), _createVNode(_unref(ElRow), {
        class: "attribute-item-row"
      }, {
        default: _withCtx(() => [_cache[12] || (_cache[12] = _createElementVNode("text", {
          class: "attribute-item-title"
        }, "角色名", -1)), _createElementVNode("text", _hoisted_7, _toDisplayString(attribute.value.nickname), 1)]),
        _: 1
      }), _createVNode(_unref(ElRow), {
        class: "attribute-item-row"
      }, {
        default: _withCtx(() => [_cache[13] || (_cache[13] = _createElementVNode("text", {
          class: "attribute-item-title"
        }, "角色性别", -1)), _createElementVNode("text", _hoisted_8, _toDisplayString(_unref(getGender)(attribute.value['gender'])), 1)]),
        _: 1
      }), _createVNode(_unref(ElRow), {
        class: "attribute-item-row"
      }, {
        default: _withCtx(() => [_cache[14] || (_cache[14] = _createElementVNode("text", {
          class: "attribute-item-title"
        }, "链接年龄", -1)), _createElementVNode("text", _hoisted_9, _toDisplayString(attribute.value['age']) + "岁", 1)]),
        _: 1
      }), _createVNode(_unref(ElRow), {
        class: "attribute-item-row"
      }, {
        default: _withCtx(() => [_cache[15] || (_cache[15] = _createElementVNode("text", {
          class: "attribute-item-title"
        }, "角色种族", -1)), _createElementVNode("text", _hoisted_10, _toDisplayString(attribute.value['race']), 1)]),
        _: 1
      }), _createVNode(_unref(ElRow), {
        class: "attribute-item-row"
      }, {
        default: _withCtx(() => [_cache[16] || (_cache[16] = _createElementVNode("text", {
          class: "attribute-item-title"
        }, "链接时代", -1)), _createElementVNode("text", _hoisted_11, _toDisplayString(attribute.value['era']), 1)]),
        _: 1
      }), _createVNode(_unref(ElRow), {
        class: "attribute-item-row"
      }, {
        default: _withCtx(() => [_cache[17] || (_cache[17] = _createElementVNode("text", {
          class: "attribute-item-title"
        }, "过往国籍", -1)), _createElementVNode("text", _hoisted_12, _toDisplayString(attribute.value['nationality']), 1)]),
        _: 1
      }), _createVNode(_unref(ElRow), {
        class: "attribute-item-row"
      }, {
        default: _withCtx(() => [_cache[18] || (_cache[18] = _createElementVNode("text", {
          class: "attribute-item-title"
        }, "过往职业", -1)), _createElementVNode("text", _hoisted_13, _toDisplayString(attribute.value['work']), 1)]),
        _: 1
      }), _cache[24] || (_cache[24] = _createElementVNode("div", {
        class: "group-gap"
      }, null, -1)), _createVNode(_unref(ElRow), {
        class: "attribute-item-row"
      }, {
        default: _withCtx(() => [_cache[19] || (_cache[19] = _createElementVNode("text", {
          class: "attribute-item-title"
        }, "从属世界观", -1)), _createElementVNode("text", _hoisted_14, _toDisplayString(attribute.value.world_outlook.name), 1)]),
        _: 1
      }), _createVNode(_unref(ElRow), {
        class: "attribute-item-row"
      }, {
        default: _withCtx(() => [_cache[20] || (_cache[20] = _createElementVNode("text", {
          class: "attribute-item-title"
        }, "所处境界", -1)), _createElementVNode("text", _hoisted_15, _toDisplayString(`${attribute.value['realm']} ${attribute.value['level']}`), 1)]),
        _: 1
      }), _createVNode(_unref(ElRow), {
        class: "attribute-item-row"
      }, {
        default: _withCtx(() => [_cache[21] || (_cache[21] = _createElementVNode("text", {
          class: "attribute-item-title"
        }, "经验积蓄", -1)), _createElementVNode("text", _hoisted_16, _toDisplayString(`${attribute.value['experience']} / ${attribute.value['critical_experience']}`), 1)]),
        _: 1
      }), !attribute.value.is_lead ? (_openBlock(), _createBlock(_unref(ElRow), {
        key: 2,
        class: "attribute-item-row"
      }, {
        default: _withCtx(() => [_cache[23] || (_cache[23] = _createElementVNode("text", {
          class: "attribute-item-title"
        }, "核心角色", -1)), _createElementVNode("div", _hoisted_17, [_createVNode(_unref(ElButton), {
          class: "lead-switch",
          onClick: switchLeadRole
        }, {
          default: _withCtx(() => [...(_cache[22] || (_cache[22] = [_createTextVNode(" 设为主要角色 ", -1)]))]),
          _: 1
        })])]),
        _: 1
      })) : _createCommentVNode("", true)]), _createElementVNode("div", _hoisted_18, [_createVNode(_unref(ElRow), {
        class: "attribute-group-title-row"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_icon, {
          size: 18
        }, {
          default: _withCtx(() => [_createVNode(_unref(Connection))]),
          _: 1
        }), _cache[25] || (_cache[25] = _createElementVNode("text", {
          class: "group-title"
        }, "世界链接", -1))]),
        _: 1
      }), attribute.value.organizations && attribute.value.organizations.length > 0 ? (_openBlock(), _createElementBlock("div", _hoisted_19, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(attribute.value.organizations, (item, index) => {
        return _openBlock(), _createElementBlock("div", {
          key: index,
          class: "attribute-item-column-row"
        }, [_createElementVNode("text", _hoisted_20, [_createTextVNode(_toDisplayString(item.name) + " ", 1), item.is_core ? (_openBlock(), _createElementBlock("span", _hoisted_21, "(核心)")) : _createCommentVNode("", true)]), _createElementVNode("text", _hoisted_22, _toDisplayString(item.position_held && item.position_held.length > 0 ? item.position_held : '普通成员'), 1)]);
      }), 128)), _cache[26] || (_cache[26] = _createElementVNode("div", {
        class: "group-gap"
      }, null, -1))])) : _createCommentVNode("", true), attribute.value.feats_level > 0 && attribute.value.feats_level <= _unref(featOptions).length ? (_openBlock(), _createBlock(_unref(ElRow), {
        key: 1,
        class: "attribute-item-row"
      }, {
        default: _withCtx(() => [_cache[27] || (_cache[27] = _createElementVNode("text", {
          class: "attribute-item-title"
        }, "组织功勋", -1)), _createElementVNode("text", _hoisted_23, _toDisplayString(_unref(featOptions)[attribute.value.feats_level - 1]) + "级 ", 1)]),
        _: 1
      })) : _createCommentVNode("", true), _createVNode(_unref(ElRow), {
        class: "attribute-item-row"
      }, {
        default: _withCtx(() => [_cache[28] || (_cache[28] = _createElementVNode("text", {
          class: "attribute-item-title"
        }, "演出履历", -1)), _createElementVNode("text", _hoisted_24, _toDisplayString(attribute.value.resumes) + "场", 1)]),
        _: 1
      }), _createVNode(_unref(ElRow), {
        class: "attribute-item-row"
      }, {
        default: _withCtx(() => [_cache[29] || (_cache[29] = _createElementVNode("text", {
          class: "attribute-item-title"
        }, "神秘等级", -1)), _createElementVNode("text", _hoisted_25, _toDisplayString(attribute.value.mysterious_level), 1)]),
        _: 1
      }), _createVNode(_unref(ElRow), {
        class: "attribute-item-row"
      }, {
        default: _withCtx(() => [_cache[30] || (_cache[30] = _createElementVNode("text", {
          class: "attribute-item-title"
        }, "神话知识", -1)), _createElementVNode("text", _hoisted_26, _toDisplayString(attribute.value.mythology), 1)]),
        _: 1
      })])]), _cache[58] || (_cache[58] = _createElementVNode("div", {
        style: {
          "width": "1.0rem"
        }
      }, null, -1)), _createElementVNode("div", _hoisted_27, [_createElementVNode("div", _hoisted_28, [_createVNode(_component_el_image, {
        src: attribute.value.avatar,
        class: "role-avatar"
      }, {
        default: _withCtx(() => [_createElementVNode("img", {
          src: _unref(placeholderImage),
          alt: "角色头像占位"
        }, null, 8, _hoisted_29)]),
        _: 1
      }, 8, ["src"]), _createVNode(_unref(ElRow), {
        class: "attribute-group-title-row"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_icon, {
          size: 18
        }, {
          default: _withCtx(() => [_createVNode(_unref(Notebook))]),
          _: 1
        }), _cache[31] || (_cache[31] = _createElementVNode("text", {
          class: "group-title"
        }, "角色背景", -1))]),
        _: 1
      }), _createVNode(_unref(ElRow), {
        class: "attribute-item-row-pure",
        style: {
          "flex": "1"
        }
      }, {
        default: _withCtx(() => [_createElementVNode("text", _hoisted_30, _toDisplayString(attribute.value.biography && attribute.value.biography.length > 0 ? attribute.value.biography : '故事永远都在继续'), 1)]),
        _: 1
      }), _cache[34] || (_cache[34] = _createElementVNode("div", {
        class: "group-gap"
      }, null, -1)), _unref(isUserType)(userType.value) ? (_openBlock(), _createBlock(_unref(ElRow), {
        key: 0,
        class: "attribute-item-row",
        style: {
          "justify-content": "flex-end",
          "gap": "16px"
        }
      }, {
        default: _withCtx(() => [_createVNode(_unref(ElButton), {
          onClick: clickAvatar
        }, {
          default: _withCtx(() => [...(_cache[32] || (_cache[32] = [_createTextVNode(" 上传图片 ", -1)]))]),
          _: 1
        }), _createVNode(_unref(ElButton), {
          onClick: _cache[0] || (_cache[0] = $event => {
            biography.value = attribute.value.biography;
            biographyMode.value = true;
          })
        }, {
          default: _withCtx(() => [...(_cache[33] || (_cache[33] = [_createTextVNode(" 新的变化 ", -1)]))]),
          _: 1
        })]),
        _: 1
      })) : _createCommentVNode("", true)]), _createElementVNode("div", _hoisted_31, [_createVNode(_unref(ElRow), {
        class: "attribute-group-title-row"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_icon, {
          size: 18
        }, {
          default: _withCtx(() => [_createVNode(_unref(Postcard))]),
          _: 1
        }), _cache[35] || (_cache[35] = _createElementVNode("text", {
          class: "group-title"
        }, "能力延伸", -1))]),
        _: 1
      }), _createVNode(_unref(ElRow), {
        class: "attribute-item-grid"
      }, {
        default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(attribute.value['properties'], (value, key, index) => {
          return _openBlock(), _createElementBlock("div", {
            key: index,
            class: "attribute-item-grid-card"
          }, [_createElementVNode("text", _hoisted_32, _toDisplayString(`${_unref(getProperty)(key)}(${key})`), 1), _createElementVNode("text", _hoisted_33, _toDisplayString(value), 1)]);
        }), 128))]),
        _: 1
      }), _cache[44] || (_cache[44] = _createElementVNode("div", {
        class: "group-gap"
      }, null, -1)), _cache[45] || (_cache[45] = _createElementVNode("div", {
        class: "group-gap"
      }, null, -1)), _createVNode(_unref(ElRow), {
        class: "attribute-item-row-pure"
      }, {
        default: _withCtx(() => [_createVNode(_unref(ElCol), {
          span: 8
        }, {
          default: _withCtx(() => [_createVNode(_unref(ElRow), null, {
            default: _withCtx(() => [_cache[36] || (_cache[36] = _createElementVNode("text", {
              class: "attribute-item-title"
            }, "生命值", -1)), _createVNode(_unref(ElProgress), {
              percentage: 100,
              "text-inside": true,
              "stroke-width": 16,
              class: "attribute-item-progress hp_progress"
            }, {
              default: _withCtx(() => [_createElementVNode("text", _hoisted_34, _toDisplayString(`${attribute.value.health_point} / ${attribute.value.health_point}`), 1)]),
              _: 1
            })]),
            _: 1
          })]),
          _: 1
        }), _createVNode(_unref(ElCol), {
          span: 8
        }, {
          default: _withCtx(() => [_createVNode(_unref(ElRow), null, {
            default: _withCtx(() => [_cache[37] || (_cache[37] = _createElementVNode("text", {
              class: "attribute-item-title"
            }, "法力值", -1)), _createVNode(_unref(ElProgress), {
              percentage: 100,
              "text-inside": true,
              "stroke-width": 16,
              class: "attribute-item-progress mp_progress"
            }, {
              default: _withCtx(() => [_createElementVNode("text", _hoisted_35, _toDisplayString(`${attribute.value.magic_point} / ${attribute.value.magic_point}`), 1)]),
              _: 1
            })]),
            _: 1
          })]),
          _: 1
        }), _createVNode(_unref(ElCol), {
          span: 8
        }, {
          default: _withCtx(() => [_createVNode(_unref(ElRow), null, {
            default: _withCtx(() => [_cache[38] || (_cache[38] = _createElementVNode("text", {
              class: "attribute-item-title"
            }, "理智值", -1)), _createVNode(_unref(ElProgress), {
              percentage: 100,
              "text-inside": true,
              "stroke-width": 16,
              class: "attribute-item-progress san_progress"
            }, {
              default: _withCtx(() => [_createElementVNode("text", _hoisted_36, _toDisplayString(sanityDesc.value), 1)]),
              _: 1
            })]),
            _: 1
          })]),
          _: 1
        })]),
        _: 1
      }), _cache[46] || (_cache[46] = _createElementVNode("div", {
        class: "group-gap"
      }, null, -1)), _createVNode(_unref(ElRow), null, {
        default: _withCtx(() => [_createVNode(_unref(ElCol), {
          span: 8
        }, {
          default: _withCtx(() => [_createVNode(_unref(ElRow), {
            class: "attribute-item-row"
          }, {
            default: _withCtx(() => [_cache[39] || (_cache[39] = _createElementVNode("text", {
              class: "attribute-item-title"
            }, "物理强度", -1)), _createElementVNode("text", _hoisted_37, _toDisplayString(`${damageAndBuild.value[0][1]}（${damageAndBuild.value[0][0]}）`), 1)]),
            _: 1
          })]),
          _: 1
        }), _createVNode(_unref(ElCol), {
          span: 8
        }, {
          default: _withCtx(() => [_createVNode(_unref(ElRow), {
            class: "attribute-item-row"
          }, {
            default: _withCtx(() => [_cache[40] || (_cache[40] = _createElementVNode("text", {
              class: "attribute-item-title"
            }, "灵体强度", -1)), _createElementVNode("text", _hoisted_38, _toDisplayString(`${damageAndBuild.value[1][1]}（${damageAndBuild.value[1][0]}）`), 1)]),
            _: 1
          })]),
          _: 1
        }), _createVNode(_unref(ElCol), {
          span: 8
        }, {
          default: _withCtx(() => [_createVNode(_unref(ElRow), {
            class: "attribute-item-row"
          }, {
            default: _withCtx(() => [_cache[41] || (_cache[41] = _createElementVNode("text", {
              class: "attribute-item-title"
            }, "移动力", -1)), _createElementVNode("text", _hoisted_39, _toDisplayString(_unref(getMovement)(attribute.value)), 1)]),
            _: 1
          })]),
          _: 1
        })]),
        _: 1
      }), _createVNode(_unref(ElRow), null, {
        default: _withCtx(() => [_createVNode(_unref(ElCol), {
          span: 8
        }, {
          default: _withCtx(() => [_createVNode(_unref(ElRow), {
            class: "attribute-item-row"
          }, {
            default: _withCtx(() => [_cache[42] || (_cache[42] = _createElementVNode("text", {
              class: "attribute-item-title"
            }, "承载力", -1)), _createElementVNode("text", _hoisted_40, _toDisplayString(attribute.value.load_value), 1)]),
            _: 1
          })]),
          _: 1
        }), _createVNode(_unref(ElCol), {
          span: 8
        }), _createVNode(_unref(ElCol), {
          span: 8
        })]),
        _: 1
      }), _cache[47] || (_cache[47] = _createElementVNode("div", {
        class: "group-gap"
      }, null, -1)), _createVNode(_unref(ElRow), null, {
        default: _withCtx(() => [_createVNode(_unref(ElCol), {
          span: 8
        }), _createVNode(_unref(ElCol), {
          span: 8
        }), _createVNode(_unref(ElCol), {
          span: 8
        }, {
          default: _withCtx(() => [_createVNode(_unref(ElRow), {
            class: "attribute-item-row",
            style: {
              "justify-content": "flex-end"
            }
          }, {
            default: _withCtx(() => [_createVNode(_unref(ElButton), {
              onClick: getInstruction
            }, {
              default: _withCtx(() => [...(_cache[43] || (_cache[43] = [_createTextVNode(" 获取录卡指令 ", -1)]))]),
              _: 1
            })]),
            _: 1
          })]),
          _: 1
        })]),
        _: 1
      })]), _createElementVNode("div", _hoisted_41, [_createVNode(_unref(ElRow), {
        class: "attribute-group-title-row"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_icon, {
          size: 18
        }, {
          default: _withCtx(() => [_createVNode(_unref(Coin))]),
          _: 1
        }), _cache[48] || (_cache[48] = _createElementVNode("text", {
          class: "group-title"
        }, "持有资源 ", -1))]),
        _: 1
      }), _createVNode(_unref(ElRow), {
        class: "attribute-item-row-pure"
      }, {
        default: _withCtx(() => [_cache[49] || (_cache[49] = _createElementVNode("text", {
          class: "attribute-item-title"
        }, "资产点数", -1)), _createVNode(_unref(ElProgress), {
          color: _unref(gradientPercentageColors),
          percentage: _unref(getPercentage)(wealthPoint.value, 200),
          "text-inside": true,
          "stroke-width": 16,
          class: "attribute-item-progress"
        }, {
          default: _withCtx(() => [_createElementVNode("text", _hoisted_42, _toDisplayString(`${wealthPoint.value.toFixed(1)} / 200.0`), 1)]),
          _: 1
        }, 8, ["color", "percentage"])]),
        _: 1
      }), _cache[55] || (_cache[55] = _createElementVNode("div", {
        class: "group-gap"
      }, null, -1)), _createVNode(_unref(ElRow), {
        class: "attribute-item-row-pure"
      }, {
        default: _withCtx(() => [_createVNode(_unref(ElCol), {
          span: 12
        }, {
          default: _withCtx(() => [_createVNode(_unref(ElRow), null, {
            default: _withCtx(() => [_cache[50] || (_cache[50] = _createElementVNode("text", {
              class: "attribute-item-title"
            }, "能力分配", -1)), _createVNode(_unref(ElProgress), {
              percentage: _unref(getPercentage)(assignableCapabilityPoint.value, attribute.value.capability_point),
              "text-inside": true,
              "stroke-width": 16,
              class: "attribute-item-progress resources_progress"
            }, {
              default: _withCtx(() => [_createElementVNode("text", _hoisted_43, _toDisplayString(`${assignableCapabilityPoint.value} / ${attribute.value.capability_point}`), 1)]),
              _: 1
            }, 8, ["percentage"])]),
            _: 1
          })]),
          _: 1
        }), _createVNode(_unref(ElCol), {
          span: 12
        }, {
          default: _withCtx(() => [_createVNode(_unref(ElRow), null, {
            default: _withCtx(() => [_cache[51] || (_cache[51] = _createElementVNode("text", {
              class: "attribute-item-title"
            }, "技能精进", -1)), _createVNode(_unref(ElProgress), {
              percentage: _unref(getPercentage)(assignableSkillsPoint.value, attribute.value.skill_point),
              "text-inside": true,
              "stroke-width": 16,
              class: "attribute-item-progress resources_progress"
            }, {
              default: _withCtx(() => [_createElementVNode("text", _hoisted_44, _toDisplayString(`${assignableSkillsPoint.value} / ${attribute.value.skill_point}`), 1)]),
              _: 1
            }, 8, ["percentage"])]),
            _: 1
          })]),
          _: 1
        })]),
        _: 1
      }), _cache[56] || (_cache[56] = _createElementVNode("div", {
        class: "group-gap"
      }, null, -1)), _createVNode(_unref(ElRow), null, {
        default: _withCtx(() => [_createVNode(_unref(ElCol), {
          span: 8
        }, {
          default: _withCtx(() => [attribute.value.reborn > 0 ? (_openBlock(), _createBlock(_unref(ElRow), {
            key: 0,
            class: "attribute-item-row-pure"
          }, {
            default: _withCtx(() => [_createElementVNode("text", _hoisted_45, "尚可重构" + _toDisplayString(attribute.value.reborn) + "次", 1)]),
            _: 1
          })) : _createCommentVNode("", true)]),
          _: 1
        }), _createVNode(_unref(ElCol), {
          span: 8
        }), _createVNode(_unref(ElCol), {
          span: 8
        })]),
        _: 1
      }), _cache[57] || (_cache[57] = _createElementVNode("div", {
        class: "group-gap"
      }, null, -1)), _createVNode(_unref(ElRow), {
        style: {
          "align-items": "center",
          "justify-content": "flex-end"
        }
      }, {
        default: _withCtx(() => [(attribute.value?.reborn ?? 0) > 0 && _unref(isUserType)(userType.value) ? (_openBlock(), _createBlock(_unref(ElButton), {
          key: 0,
          onClick: rebuildRole
        }, {
          default: _withCtx(() => [...(_cache[52] || (_cache[52] = [_createTextVNode(" 重新构建 ", -1)]))]),
          _: 1
        })) : _createCommentVNode("", true), roleArray.value.length > 1 && _unref(isUserType)(userType.value) ? (_openBlock(), _createBlock(_unref(ElButton), {
          key: 1,
          onClick: _cache[1] || (_cache[1] = $event => allocationMode.value = true)
        }, {
          default: _withCtx(() => [...(_cache[53] || (_cache[53] = [_createTextVNode(" 角色资产分配 ", -1)]))]),
          _: 1
        })) : _unref(isAdminType)(userType.value) ? (_openBlock(), _createBlock(_unref(ElButton), {
          key: 2,
          onClick: _cache[2] || (_cache[2] = $event => allocationMode.value = true)
        }, {
          default: _withCtx(() => [...(_cache[54] || (_cache[54] = [_createTextVNode(" 资产点数调整 ", -1)]))]),
          _: 1
        })) : _createCommentVNode("", true)]),
        _: 1
      })])])])) : _createCommentVNode("", true), instructionMode.value ? (_openBlock(), _createBlock(_Teleport, {
        key: 1,
        to: "#mask-container"
      }, [instructionMode.value ? (_openBlock(), _createBlock(MaskerLayer, {
        key: 0,
        onClose: _cache[3] || (_cache[3] = $event => instructionMode.value = false)
      }, {
        default: _withCtx(() => [_createElementVNode("div", _hoisted_46, [_cache[59] || (_cache[59] = _createElementVNode("text", {
          class: "instruction-title"
        }, "录卡指令", -1)), _createElementVNode("text", _hoisted_47, _toDisplayString(instruction.value), 1)])]),
        _: 1
      })) : _createCommentVNode("", true)])) : _createCommentVNode("", true), allocationMode.value ? (_openBlock(), _createBlock(_Teleport, {
        key: 2,
        to: "#mask-container"
      }, [_createVNode(MaskerLayer, {
        onClose: _cache[5] || (_cache[5] = $event => allocationMode.value = false)
      }, {
        default: _withCtx(() => [_createVNode(AssetAllocation, {
          "role-id": __props.roleId,
          onUpdate: getData,
          onClose: _cache[4] || (_cache[4] = $event => allocationMode.value = false)
        }, null, 8, ["role-id"])]),
        _: 1
      })])) : _createCommentVNode("", true), biographyMode.value ? (_openBlock(), _createBlock(_Teleport, {
        key: 3,
        to: "#mask-container"
      }, [_createVNode(MaskerLayer, {
        onClose: _cache[7] || (_cache[7] = $event => biographyMode.value = false)
      }, {
        default: _withCtx(() => [_createElementVNode("div", _hoisted_48, [_cache[61] || (_cache[61] = _createElementVNode("text", {
          class: "biography-title"
        }, "角色生平", -1)), _createVNode(_unref(ElInput), {
          modelValue: biography.value,
          "onUpdate:modelValue": _cache[6] || (_cache[6] = $event => biography.value = $event),
          type: "textarea",
          clearable: "",
          "show-word-limit": "",
          round: "",
          placeholder: "一段简要生平...",
          maxlength: "512"
        }, null, 8, ["modelValue"]), _createVNode(_unref(ElRow), {
          style: {
            "width": "100%",
            "justify-content": "flex-end"
          }
        }, {
          default: _withCtx(() => [_createVNode(_unref(ElButton), {
            onClick: submitBiography
          }, {
            default: _withCtx(() => [...(_cache[60] || (_cache[60] = [_createTextVNode(" 提交变更 ", -1)]))]),
            _: 1
          })]),
          _: 1
        })])]),
        _: 1
      })])) : _createCommentVNode("", true)], 64);
    };
  }

};